module.exports = __webpack_public_path__ + "img/contentImgHover6.aa0e8e0.webp";